export default function (url, windowName, win, w, h, otherParams) {
  const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
  const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
  const otherParamString = otherParams ? `,${otherParams}` : '';
  return win.open(url, windowName, `width=${w},height=${h},left=${x},top=${y}${otherParamString}`);
}
